import { useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import AuthNavbar from '../../components/AuthNavbar/AuthNavbar';
import DashBoardNavbar from '../../components/DashboardNavbar/DashBoardNavbar';

const SharedLayout = () => {
  // const [user, setUser] = useState(null);
  const token = sessionStorage.getItem('user');
  const location = useLocation();
  useEffect(() => {}, []);

  return (
    <>
      {token ? (
        <DashBoardNavbar user={token ? JSON.parse(token) : null} />
      ) : (
        <AuthNavbar />
      )}
      <Outlet />
    </>
  );
};
export default SharedLayout;
